<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.summaryReport.summaryReport") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 px-2 flex justify-center lg:ml-6 lg:justify-start">
            <Listbox as="div" v-model="selected">
              <div class="relative w-48">
                <ListboxButton
                  class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                  <span class="block truncate">{{ selected.label }}</span>
                  <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </span>
                </ListboxButton>

                <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                  leave-to-class="opacity-0">
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    <ListboxOption as="template" v-for="month in months" :key="month.label" :value="month"
                      @click="search(month)">
                      <li :class="[
                        'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                      ]">
                        <span :class="[
                          selected.value == month.value
                            ? 'font-semibold'
                            : 'font-normal',
                          'block truncate text-left',
                        ]">
                          {{ month.label }}
                        </span>

                        <span v-if="selected.value == month.value" :class="[
                          'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                        ]">
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox>
          </div>
          <div class="flex flex-row mr-auto">
            <DateSelector @search="onDateSelect" />
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <button type="button" @click="showAdvanced = true"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
              {{ $t("messages.summaryReport.advanceFilter") }}
            </button>
            <button type="button" @click="exports()"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
              {{ $t("messages.summaryReport.exportReport") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div> -->

    <div class="relative py-6">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" @click="doSort('userName')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                    {{ $t("messages.summaryReport.user") }}
                  </th>
                  <th scope="col" @click="doSort('bet_count')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    {{ $t("messages.summaryReport.totalBetRounds") }}
                  </th>
                  <th scope="col" @click="doSort('bet_amount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.summaryReport.betAmount") }}
                  </th>
                  <th scope="col" @click="doSort('valid_bet_amount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.summaryReport.validBetAmount") }}
                  </th>
                  <th scope="col" @click="doSort('win_loss')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.summaryReport.winloss") }}
                  </th>
                  <th scope="col" @click="doSort('win_loss')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer">
                    {{ $t("messages.summaryReport.winlossPercent") }}
                  </th>
                  <!-- <th
                    scope="col"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
                  >
                    Date
                  </th> -->
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500" style="color: #4169e1">
                    {{ data.userName }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{
                      data.TotalBet.toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      (parseFloat(data.betAmount) / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      (parseFloat(data.validBetAmount) / 100).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="parseFloat(data.winLoss / 100) >= 0
                      ? { color: 'green' }
                      : { color: 'red' }
                    ">
                    {{
                      (parseFloat(data.winLoss) / 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="parseFloat(data.winLossPercentage) >= 0
                      ? { color: 'green' }
                      : { color: 'red' }
                    ">
                    <span v-if="data.winLossPercentage">{{
                      (data.winLossPercentage * 100).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 4,
                      })
                    }}%</span>
                    <span v-else> - </span>
                  </td>
                  <!-- <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
                  >
                    {{ dayjs(selected.value).format("MMMM YYYY") }}
                  </td> -->
                </tr>
              </tbody>
            </table>
            <Pagination v-model:config="pageConfig" isLagacy />
          </div>
        </div>
      </div>
    </div>
  </div>
  <SummaryReportFilterDialog v-model:show="showAdvanced" v-model:form="filter" @filter="refetch(true, selectedDate)" />
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import Pagination from "@/components/tools/Pagination.vue";
import SummaryReportFilterDialog from "@/components/dialogs/SummaryReportFilterDialog.vue";
import DateSelector from "@/components/tools/DateSelector.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Summary Report", href: "", current: true }];
const rowsPerPageOption = [
  { label: "2", value: 2 },
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
    Pagination,
    SummaryReportFilterDialog,
    DateSelector,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toDate = ref("");
    const currentPage = ref(1);
    const offset = ref(0);
    const rowsPerPage = ref({ label: "10", value: 10 });
    const DateState =  ref({ from: null, to: null });
    const startDate = dayjs();
    const diff = startDate.diff("2021-07-01", "months");
    let isFilter = ref(false);
    let months = ref([]);
    console.log(diff)
    for (let i = 0; i <= diff; i++) {
      console.log(dayjs("2021-07-01").add(i, "month").format("MM/YYYY"))
      months.value.push({
        label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
        value: dayjs("2021-07-01").add(i, "month").format(),
      });
    }

    months.value.sort((a, b) => (dayjs(b.value).isAfter(dayjs(a.value)) ? 1 : -1));

    const yesterday = {
      label: "Yesterday",
      value: dayjs().add(-1, "day").format(),
    };
    months.value.unshift(yesterday);
    const selected = ref(months.value[0]);

    const filter = ref({
      username: undefined,
    });
    const pageConfig = ref({
      page: route.query.page || 1,
      count: 0,
      pageCount: 0,
      rowsPerPage: 10,
      dataLength: 0,
      search: undefined,
      sort: [["userName", "DESC"]],
    });

    // for (let i = 0; i <= diff; i++) {
    //   months.value.push({
    //     label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
    //     value: dayjs("2021-07-01").add(i, "month").format(),
    //   });
    // }

    const showAdvanced = ref(false);

    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      isLoaded.value = false;
      let fromParams, toParams;
      if (DateState.value.from || DateState.value.to) {
        fromParams = DateState.value.from
            ? dayjs(DateState.value.from).format()
            : dayjs(selected.value.value).startOf("month").format();
        toParams = DateState.value.to
            ? dayjs(DateState.value.to).endOf('day').format()
            : dayjs().endOf('day').format();
      }else if(selected.value.label == "Yesterday"){
        fromParams = dayjs(selected.value.value)
            .hour(0)
            .minute(0)
            .second(0)
            .format();
        toParams = dayjs(selected.value.value)
            .hour(23)
            .minute(59)
            .second(59)
            .format();
      }else{
        fromParams = DateState.value.from
            ? dayjs(DateState.value.from).format()
            : dayjs(selected.value.value).startOf("month").format();
        toParams = DateState.value.to
            ? dayjs(DateState.value.to).endOf('day').format()
            : dayjs(selected.value.value).endOf("month").endOf('day').format();
      }

      let sort = pageConfig.value.sort;
      // if (isFilter.value == true) {
      //   pageConfig.value.page = parseInt(route.query.page)
      // }
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/summary-report-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
              playerName: filter?.value.username,
              offset:
                pageConfig.value.rowsPerPage * (pageConfig.value.page - 1),
              limit: pageConfig.value.rowsPerPage,
              sort,
            },
          }
        )
        .then(({ data }) => {
          dataRows.value = data.result.rows;
          dataCount.value = data.result.rows.length;
          pageConfig.value.dataLength = data.result.rows.length;

          isLoaded.value = true;
        })
        .catch(({ response }) => {
          console.log(response.data);
        });
      window.history.replaceState(
        {},
        document.title,
        `summary?${stringify({
          page: pageConfig.value.page,
          rowsPerPage: pageConfig.value.rowsPerPage,
        })}`
      );
    };

    const pageCount = () => {
      return Math.ceil(dataCount.value / rowsPerPage.value.value);
    };

    const search = (month) => {
      let from = dayjs(month.value);
      let fromParams = dayjs(month.value).startOf("month").format();
      let toParams = dayjs(month.value).endOf("month").format();
      let sort = pageConfig.value.sort;

      if (from.isValid()) {
        isLoaded.value = false;
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/report/summary-report-op",
            null,
            {
              params: {
                operatorId: store.state.selectedOperator.operatorId,
                from: fromParams,
                to: toParams,
                playerName: filter?.value.username,
                offset:
                  pageConfig.value.rowsPerPage * (pageConfig.value.page - 1),
                limit: pageConfig.value.rowsPerPage,
                sort,
              },
            }
          )
          .then(({ data }) => {
            dataRows.value = data.result.rows;
            dataCount.value = data.result.rows.length;
            isLoaded.value = true;
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const exports = () => {
      let fromParams,toParams
      if (DateState.value.from || DateState.value.to) {
        fromParams = DateState.value.from
            ? dayjs(DateState.value.from).format()
            : dayjs(selected.value.value).startOf("month").format();
        toParams = DateState.value.to
            ? dayjs(DateState.value.to).endOf('day').format()
            : dayjs().endOf('day').format();
      }else if(selected.value.label == "Yesterday"){
        fromParams = dayjs(selected.value.value)
            .hour(0)
            .minute(0)
            .second(0)
            .format();
        toParams = dayjs(selected.value.value)
            .hour(23)
            .minute(59)
            .second(59)
            .format();
      }else{
        fromParams = DateState.value.from
            ? dayjs(DateState.value.from).format()
            : dayjs(selected.value.value).startOf("month").format();
        toParams = DateState.value.to
            ? dayjs(DateState.value.to).endOf('day').format()
            : dayjs(selected.value.value).endOf("month").endOf('day').format();
      }
      let sort = pageConfig.value.sort;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/report/export/summary-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
              sort,
            },
          }
        )
        .then(({ data }) => {
          window.open(data.result);
        });
    };
    watch(
      () => pageConfig.value.page,
      () => refetch()
    );
    watch(
      () => pageConfig.value.search,
      // () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = 1;
        refetch();
      }
    );
    /** fetch data when rows per page was changed */
    watch(
      () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = Number(route.query.page) || 1;
        refetch();
      }
    );

    const doSort = (attName) => {
      let sortAttr = attName;
      if (attName == "bet_count") {
        sortAttr = "TotalBet";
      }
      if (attName == "bet_amount") {
        sortAttr = "betAmount";
      }
      if (attName == "valid_bet_amount") {
        sortAttr = "validBetAmount";
      }
      if (attName == "win_loss") {
        sortAttr = "winLoss";
      }
      if (pageConfig.value.sort[0] && pageConfig.value.sort[0][0] == sortAttr) {
        pageConfig.value.sort[0][1] =
          pageConfig.value.sort[0][1] == "DESC" ? "ASC" : "DESC";
      } else {
        pageConfig.value.sort = [[sortAttr, "DESC"]];
      }
      isFilter.value = false;
      refetch();
    };
    const onDateSelect = (e) => {
      DateState.value = e;
      console.log(DateState.value)
      refetch();
    };
    return {
      pageConfig,
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      selected,
      toDate,
      route,
      search,
      viewData,
      months,
      pages,
      exports,
      refetch,
      rowsPerPageOption,
      rowsPerPage,
      currentPage,
      offset,
      pageCount,
      doSort,
      showAdvanced,
      filter,
      onDateSelect,
      DateState
    };
  },
};
</script>
